import { Toast, PullRefresh } from "vant";
import WeiXinShare from "@/assets/js/weiXinShare";
import common from "@/assets/js/common";

export default {
  components: {
    PullRefresh
  },
  data() {
    return {
      id: "",
      ids: "",
      name: "",
      size: 10,
      current: 0,
      loading: false,
      refreshing: false,
      floorList: [],
      floorIndex: 0,
      activity: {},
      shareVisible: false,

      scrollTop: 0
    };
  },
  created() {
    const { id } = this.$route.params;
    this.id = id;
    console.log("用户信息userIdentity", this.userIdentity);
    Toast.loading({
      mask: true,
      message: "加载中...",
      duration: 1000
    });
    this.getActivity(id);
  },

  beforeRouteLeave(to, from, next) {
    this.scrollTop = document.getElementById("list").getBoundingClientRect().top;
    next();
  },
  // 进入该页面时，用之前保存的滚动位置赋值
  beforeRouteEnter(to, from, next) {
    next(vm => {
      setTimeout(() => {
        if (document.getElementById("listWrap")) {
          console.log("beforeRouteEnter", vm.scrollTop);
          document.getElementById("listWrap").scrollTop = (-vm.scrollTop) + 45;
        }
      }, 100);
    });
  },
  methods: {
    routerClick(id) {
      this.$router.push(`/groupBuying?id=${id}`);
    },
    refresh() {
      console.log("refresh");
      this.refreshing = true;
      const { floorIndex, floorList } = this;
      const floor = floorList[floorIndex];
      floor.num = 1;
      floor.goodList = [];
      floor.finished = false;
      this.$set(this.floorList, floorIndex, floor);
      this.getGoodList(floor.id, floorIndex);
    },
    loadMore() {
      console.log("loadMore");
      const { floorIndex, floorList } = this;
      const floor = floorList[floorIndex];
      if (!floor.goodList.length) {
        return;
      }
      if (floor.num < floor.total) {
        this.loading = true;
        floor.num += 1;
        this.$set(this.floorList, floorIndex, floor);
        this.getGoodList(floor.id, floorIndex);
      }
    },

    floorChange(index) {
      this.floorIndex = index;
      const goodList = this.floorList[index].goodList || [];
      if (goodList.length) {
        return;
      }
      const floorId = this.floorList[index].id;
      this.getGoodList(floorId, index);
    },

    // 获取活动
    getActivity(id) {
      this.$store.dispatch("channel/getActivityFloorList", id).then((data) => {
        console.log("活动楼层", data);
        if (!data) {
          return;
        }
        this.activity = data || {};
        //  isExistData：是否展示楼层 0：不展示 1：展示
        const { name, customPageFloorList, mobBannerPic, shareContent } = data;
        document.title = name || "";
        const floorList = customPageFloorList.filter(item => item.isExistData);
        console.log("floorList", this.floorList);
        this.floorList = floorList.map((item) => ({
          ...item,
          num: 1,
          total: 1,
          loading: false,
          finished: false,
          goodList: []
        }));
        this.initData(name, mobBannerPic, shareContent);
        this.floorChange(0);
      });
    },

    // 获取楼层商品/店铺
    // goodsNumbers 已拼单商品数量
    // numbers 参与人数
    // firstGoodsPicUrl  商品url
    // status 状态
    // statusCn 状态说明
    // endTime 结束时间
    // name 活动名称
    // id 活动ID
    getGoodList(floorId, cusIndex) {
      const item = this.floorList[cusIndex];
      this.$store.dispatch("channel/getActivityGoodList", {
        floorId,
        pageSize: 8,
        pageNum: item.num
      }).then((data) => {
        console.log("商品列表", data);
        // total 总页数
        const { total, results } = data;
        const goodList = results.map((good) => {
          const price = good.orderGoodsMoeny ? String(good.orderGoodsMoeny).split(".") : [];
          return {
            ...good,
            price
          };
        });
        this.loading = false;
        this.refreshing = false;
        // orderGoodsMoeny
        const floor = {
          ...item,
          total,
          goodList: [...item.goodList, ...goodList]
        };
        // finished
        if (floor.num >= floor.total) {
          floor.finished = true;
        }
        this.$set(this.floorList, cusIndex, floor);
      }).finally(() => {
        Toast.clear();
      });
    },
    initData(name, mobBannerPic, shareContent) {
      setTimeout(() => {
        document.getElementById("sc_share_img").value = $.trim(mobBannerPic);
        document.getElementById("sc_share_desc").value = $.trim(shareContent);
        document.getElementById("sc_share_title").value = $.trim(name);
      }, 0);
      // 微信
      const paramWeixin = {
        title: $.trim(name.replace(/\s+/g, "")),
        desc: $.trim(shareContent.replace(/\s+/g, "")),
        link: window.location.href,
        imgUrl: $.trim(mobBannerPic)
      };
      WeiXinShare.init(paramWeixin);
      // 初始化分享
      if (common.isInWeiXin()) {
        console.info("初始化分享");
        common.initShare(name, "", window.location.href, mobBannerPic);
      }
    },

    shareList() {
      if (isInZnt()) {
        const { name, mobBannerPic, shareContent } = this.activity;
        znt.openSharePanel({
          title: $.trim(name.replace(/\s+/g, "")),
          desc: $.trim(shareContent.replace(/\s+/g, "")),
          link: window.location.href,
          imgUrl: $.trim(mobBannerPic)
        });
      } else {
        console.log("分享");
        this.shareVisible = true;
      }
    }

  }
};
